/** Employee password: ≥9 chars, lowercase, uppercase, digit (matches Prime `strongRegex`). */
export const EMPLOYEE_STRONG_PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{9,}$/;

/** String form for PrimeReact `Password` `strongRegex` / `mediumRegex` props. */
export const EMPLOYEE_STRONG_PASSWORD_REGEX_STRING =
  "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{9,}$";

export function isEmployeePasswordStrong(password: string | undefined | null) {
  if (password == null || password === "") return false;
  return EMPLOYEE_STRONG_PASSWORD_REGEX.test(password);
}
